<template>
    <div v-if="config">
        <setting-card
            v-bind="binds"
            v-model:active="config.activateTask"
            :hideMoreVert="true"
            :hidePrevious="true"
            @updateProfile="updateProfile()"
        >
            <v-row no-gutters class="d-flex justify-center" style="min-width: 600px">
                <!-- <v-col cols="8" class="pb-2 title pl-3">
                    Tâches liées aux déclarations
                </v-col> -->
                <v-col cols="8">
                    <v-list-item
                        style="border-radius: 16px !important"
                        class="oss-list-item"
                        title="Gestionnaire des t&#xe2;ches"
                    >
                        <template #append>
                            <v-switch @click="updateProfile()" v-model="config.activateTask" />
                        </template>
                    </v-list-item>
                    <!-- <v-row no-gutters class="rounded-xl px-2">
                        <v-col cols="9" class="d-flex align-center">
                            
                        </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch @click="updateProfile()" v-model="config.activateTask" />
                        </v-col> -->
                    <!-- <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                        <v-col cols="9" class="d-flex align-center">
                            T&#xe2;ches IS auto
                        </v-col>
                        <v-col cols="3" class="d-flex justify-end">
                            <v-switch 
                                @click="updateProfile()" 
                                inset dense
                                v-model="config.autoTaxTask" 
                                color="primary"
                            ></v-switch>
                        </v-col> -->
                    <!-- </v-row> -->
                </v-col>
            </v-row>
        </setting-card>
    </div>
</template>

<script lang="ts">
import settingCard from "../SettingCard.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

const BobbeeImg = require("../../../assets/img/bobbee_mini.png");

@Component({
    components: {
        settingCard,
    },
    emits: ["updateProfile"],
})
export class SettingTask extends Vue {
    @Prop({ default: null }) config!: any;

    get binds() {
        return {
            title: "Gestionnaire de tâches",
            partnerName: "bobbee",
            text: "Listez l'ensemble des tâches à effectuer sur votre dossier.",
            // logo: BobbeeImg
        };
    }

    updateProfile() {
        this.$emit("updateProfile");
    }

    validCategory = ["ALL", "OTHER"];

    searchCondition(search: string) {
        return (
            this.binds.title.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.partnerName.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.text.toLowerCase().includes(search.toLowerCase())
        );
    }

    displayCondition(
        search = "",
        tab: "ALL" | "BANK" | "MAIL" | "INVOICE" | "PAYEMENT" | "OTHER" = "ALL",
    ) {
        if (search) {
            return this.validCategory.includes(tab) && this.searchCondition(search);
        }
        return this.validCategory.includes(tab);
    }
}

export default toNative(SettingTask);
</script>
